<template>
    <div>
        <validation-observer ref="forms" v-slot="{handleSubmit}">
            <form class="form-group" @submit.prevent="handleSubmit(submitConfiguracoes)">
                <div class="grid-2">
                    <validation-provider
                        name="Sindicato"
                        vid="sindicato"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std form-text"
                    >
                        <label>Sindicatos</label>
                           <select v-model="form.sindicato_id" class="text-black">
                                <option value="" disabled></option>
                                <option v-for="(sindicato, index) in sindicatos" :key="index" :value="sindicato.id">
                                    {{sindicato.nome_fantasia}}
                                </option>
                            </select>
                        
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>
                    <validation-provider
                        name="Valor Documento"
                        vid="valor_boleto"
                        rules="required"
                        v-slot="{errors}"
                        tag="div"
                        class="input-std form-text"
                    >
                        <label>Valor do Documento</label>
                        <input type="text" v-model="form.valor_boleto" />
                        <p class="errors">{{errors[0]}}</p>
                    </validation-provider>
                </div>
     
                <div class="flex justify-end">
                    <button class="btn btn-primary">Salvar Configuração</button>
                </div>
            </form>
        </validation-observer>
    </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/airbnb.css';

const Brasil = require('flatpickr/dist/l10n/pt.js').default.pt;
export default {
    name: 'form-configurar-boleto',
    components: {
        flatPickr
    },

    created() {
        this.getSindicatos()
    },

    data() {
        return {
            sindicatos: [],
            form: {
                id: '',
                valor_boleto: '',
                tipo_juros: 'ISENTO',
                data_juros: '',
                percentual_juros: '0',
                valor_abatimento: '0',
                acao_pos_vencimento: 'DEVOLVER',
                dias_pos_vencimento: '30',
                sindicato_id: '',
            },
            config: {
                wrap: true,
                altInput: true,
                altFormat: 'd/m/Y',
                dateFormat: 'Y-m-d',
                enableTime: true,
                allowInput: true,
                locale: Brasil,
            },
        }
    },

    methods: {
       
        getSindicatos() {
            this.axios('get-all-sindicatos')
            .then(response => {
                this.sindicatos = response.data.sindicato
            })
        },

        submitConfiguracoes() {
            this.axios.post('configuracoes-boleto', this.form)
            .then(response => {
                this.$swal({
                    title: 'Sucesso',
                    text: 'Configurações salvas com sucesso.',
                    icon: 'success',
                })
                this.$router.push('/sistema/boletos/configuracoes-boleto')
            })
            .catch(error => {
                this.$swal({
                    title: 'Erro',
                    text: 'Algo de errado aconteceu.',
                    icon: 'error',
                })
            })
        }
    }
    
}
</script>